/**
 * Cadastro de clientes e alteração de status do cliente exigem o scope
 * `manage-customers-register`, hoje vinculado apenas à role Lord.
 *
 * O scope vem do token do Passport, já decodificado no store. A checagem aqui
 * é só de tela — quem burlar continua barrado no backend com 403.
 */
export const SCOPE_MANAGE_CUSTOMERS_REGISTER = 'manage-customers-register';

export const restrictedActionMixin = {
  computed: {
    canManageCustomers() {
      const scopes = this.$store.getters.currentScope;

      return Array.isArray(scopes) && scopes.includes(SCOPE_MANAGE_CUSTOMERS_REGISTER);
    },
  },
};
